module.exports = __webpack_public_path__ + "img/close_gray.8f91589b.svg";